// import CryptoJS from 'crypto-js';
// export const hashValue = (value) => {
//     // Ensure the input is a string
//     if (typeof value !== 'string') {
//       value = String(value || ''); // Convert to string or default to an empty string
//     }
//     return CryptoJS.SHA256(value.trim().toLowerCase()).toString(CryptoJS.enc.Hex);
//   }

export const hashValue = async (value) => {
  // Ensure the input is a string
  if (typeof value !== 'string') {
    value = String(value || ''); // Convert to string or default to an empty string
  }
  
  // Convert input string to lowercase and trim any extra spaces
  const input = value.trim().toLowerCase();
  
  // Compute the hash using Web Crypto API
  const hashBuffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(input));
  
  // Convert the hash buffer to a hexadecimal string
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};
  
 export const normalizeEmail = (email) => {
    // Normalize Gmail addresses
    if (email.includes('@gmail.com') || email.includes('@googlemail.com')) {
        const [username, domain] = email.split('@');
        email = username.replace(/\./g, '') + '@' + domain;
    }
    return email.trim().toLowerCase();
  }

  export const formatAndValidateE164 = (phoneNumber) => {
    // Fixed country code with '+'
    const countryCode = '91';
  
    // Remove all non-numeric characters except '+'
    let cleanedNumber = phoneNumber.replace(/[^\d+]/g, '');
  
    // Remove any leading '+' for now
    if (cleanedNumber.startsWith('+')) {
        cleanedNumber = cleanedNumber.substring(1);
    }
  
    // Ensure the number starts with country code '91'
    if (!cleanedNumber.startsWith(countryCode)) {
        cleanedNumber = countryCode + cleanedNumber;
    }
  
    // Add the `+` prefix back
    cleanedNumber = `+${cleanedNumber}`;
    console.log("cleanedNumber", cleanedNumber)
    // E.164 validation: 11 to 15 digits, including the '+' sign
    const e164Regex = /^\+?[1-9]\d{10,14}$/;
    if (e164Regex.test(cleanedNumber)) {
        return cleanedNumber; // Valid E.164 formatted number
    } else {
        return null; // Invalid format
    }
  }

  export const setValuesInLocalStorange = ( KeyName, mobile) => {
    const data = {
      mobile
    };
    // Convert the data to a JSON string
    const jsonData = JSON.stringify(data);
    // Store the JSON string in local storage
    localStorage.setItem(KeyName, jsonData);
  }
